import React from 'react';

import { useTranslation } from 'react-i18next';

import classes from './styles.module.scss';

export default function CompaniesListHeader({
  totalCount,
  showAddCompanyPopup,
}) {
  const { t } = useTranslation();

  return (
    <header className={classes.CompaniesListHeader}>
      <div>
        <h1>
          {t(
            'dashboardComponents.Companies.CompaniesList.CompaniesListHeader.companies'
          )}
        </h1>
        <div className={classes.totalCount}>
          <h6 className={classes.heading}>
            {' '}
            {t(
              'dashboardComponents.Companies.CompaniesList.CompaniesListHeader.totalCompanies'
            )}
          </h6>
          <span>{totalCount || 0}</span>
        </div>
      </div>
      <button
        type="button"
        className={classes.addCompanyButton}
        onClick={() => showAddCompanyPopup(false)}
      >
        {t(
          'dashboardComponents.Companies.CompaniesList.CompaniesListHeader.addCompany'
        )}
      </button>
    </header>
  );
}
